export const ptData = `
  <div class="paragraph">
    <div class="text-box">
      <div class="text">Last updated: 25th May 2026</div>
      <div class="text">Para facilitar a compreensão sobre a forma como tratamos os seus dados pessoais, preparámos um breve resumo da nossa Política de Privacidade. Para informações mais detalhadas, consulte a versão integral da Política de Privacidade abaixo. Recomendamos igualmente a leitura da versão integral para compreender plenamente a forma como tratamos os seus dados pessoais, bem como os direitos e opções de que dispõe relativamente aos mesmos.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">pontos principais</div>
    <div class="text-box">

    </div>
  </div>
  <div class="paragraph">
    <div class="title">Resumo</div>
    <div class="text-box">

    </div>
  </div>
  <div class="paragraph">
    <div class="title">Quem é responsável pela recolha e utilização dos seus dados?</div>
    <div class="text-box">
      <div class="text">De um modo geral, a Danghuan é responsável pela recolha e utilização dos seus dados pessoais. Para as pessoas localizadas na Europa, o responsável pelo tratamento dos dados pessoais é a Danghuan Europe S.L.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Que dados utilizamos?</div>
    <div class="text-box">
      <div class="text">Tratamos os dados que nos fornece diretamente ou que são recolhidos durante a utilização dos nossos Serviços. Podemos também receber os seus dados pessoais de terceiros e de plataformas parceiras.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Para que utilizamos os dados?</div>
    <div class="text-box">
      <div class="text">Utilizamos os seus dados pessoais apenas quando existe uma base jurídica adequada para o efeito, incluindo para a execução de um contrato, o cumprimento de obrigações legais, a prossecução dos nossos interesses legítimos ou com base no seu consentimento.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Durante quanto tempo conservamos os dados?</div>
    <div class="text-box">
      <div class="text">Não conservamos os seus dados pessoais por um período superior ao necessário para cumprir as finalidades descritas nesta Política de Privacidade, salvo se a legislação aplicável exigir um período de conservação mais longo.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Marketing</div>
    <div class="text-box">
      <div class="text">Podemos enviar-lhe informações sobre os nossos Serviços ou ofertas que possam ser do seu interesse. Quando exigido por lei, apenas o faremos com o seu consentimento.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Partilha de dados pessoais</div>
    <div class="text-box">
      <div class="text">Podemos partilhar os seus dados pessoais com empresas afiliadas, prestadores de serviços logísticos, parceiros de pagamento, plataformas parceiras e outros prestadores de serviços, quando tal seja necessário para prestar os nossos Serviços ou cumprir obrigações legais.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Segurança</div>
    <div class="text-box">
      <div class="text">Aplicamos medidas técnicas e organizativas adequadas para proteger os seus dados pessoais.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Os seus direitos</div>
    <div class="text-box">
      <div class="text">Dependendo da legislação aplicável, poderá ter o direito de aceder aos seus dados, retificá-los, apagá-los, limitar o seu tratamento ou opor-se ao tratamento.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Crianças</div>
    <div class="text-box">
      <div class="text">Os nossos Serviços destinam-se a utilizadores com idade igual ou superior a 18 anos.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Transferências internacionais de dados</div>
    <div class="text-box">
      <div class="text">Os seus dados pessoais podem ser transferidos para outros países mediante a aplicação de salvaguardas adequadas.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Atualizações</div>
    <div class="text-box">
      <div class="text">Podemos atualizar periodicamente esta Política de Privacidade.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Contacto</div>
    <div class="text-box">
      <div class="text">Em caso de dúvidas, pode contactar-nos através de:  <span class="email">privacy@danghuan.eu</span></div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">POLÍTICA DE PRIVACIDADE</div>
    <div class="text-box">
      <div class="text">A presente Política de Privacidade descreve a forma como a Danghuan Europe S.L. e as suas empresas afiliadas (“Danghuan”, “nós”, “nos” ou “nosso”) recolhem, utilizam, divulgam, transferem, armazenam e, de outra forma, tratam os seus dados pessoais quando utiliza os nossos serviços, incluindo os nossos websites, serviços de recompra de dispositivos, serviços de revenda, serviços logísticos, plataformas online e outros serviços relacionados (conjuntamente, os “Serviços”).</div>
      <div class="text">Leia atentamente esta Política de Privacidade e as nossas práticas de privacidade antes de começar a utilizar os nossos Serviços ou de nos fornecer dados pessoais.</div>
      <div class="text">Para além desta Política de Privacidade, poderão aplicar-se informações adicionais em matéria de privacidade a determinados Serviços. Quando aplicável, disponibilizaremos as respetivas informações adicionais.</div>
      <div class="text">As disposições gerais da Secção A aplicam-se independentemente do seu local de residência. A Secção B aplica-se exclusivamente aos clientes localizados na União Europeia, Liechtenstein, Noruega, Reino Unido ou Suíça (“Europa”).</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">A. DISPOSIÇÕES GERAIS</div>
    <div class="text-box">

    </div>
  </div>
  <div class="paragraph">
    <div class="title">I. Responsabilidade</div>
    <div class="text-box">
      <div class="text">Desenvolvemos a nossa atividade e disponibilizamos os nossos Serviços a nível mundial. No entanto, o âmbito dos nossos Serviços pode variar consoante o seu local de residência.</div>
      <div class="text">• Danghuan Europe S.L.como responsável pelo tratamento:Se residir na Europa, a Danghuan Europe S.L. é responsável pelo tratamento dos seus dados pessoais conforme descrito nesta Política de Privacidade.</div>
      <div class="text">• De um modo geral, a Danghuan é responsável pelo tratamento e exerce controlo sobre o tratamento dos dados pessoais recolhidos através dos Serviços fora da Europa, comprometendo-se a proteger e respeitar a sua privacidade.</div>
      <div class="text">Por conseguinte, as referências a “Danghuan”, “nós” e “nos” referem-se à Danghuan Europe S.L. ou à entidade afiliada aplicável, dependendo da sua localização.</div>
      <div class="text">Tenha em atenção que, relativamente aos serviços logísticos, processamento de pagamentos, serviços pós-venda ou transações realizadas através de plataformas parceiras, determinados parceiros autorizados ou prestadores de serviços externos podem tratar os seus dados pessoais de forma independente no âmbito dos serviços que prestam.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">II. Como recolhemos dados pessoais e que tipos de dados pessoais recolhemos</div>
    <div class="text-box">
      <div class="text">Por “dados pessoais” entende-se qualquer informação relativa a uma pessoa singular identificada ou identificável.</div>
      <div class="text">Podemos recolher dados pessoais através dos seguintes canais:</div>
      <div class="text">• dados pessoais fornecidos diretamente por si;</div>
      <div class="text">• dados pessoais recolhidos automaticamente durante a utilização dos nossos Serviços;</div>
      <div class="text">• dados pessoais obtidos junto de terceiros ou de plataformas parceiras.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">1. Dados pessoais fornecidos diretamente por si</div>
    <div class="text-box">
      <div class="text">Pode fornecer-nos diretamente dados pessoais. No entanto, se determinados dados pessoais forem necessários para a prestação dos nossos Serviços e optar por não os fornecer, poderemos não conseguir prestar os Serviços solicitados.</div>
      <div class="text">Os dados pessoais que podemos recolher diretamente junto de si incluem:</div>
      <div class="text">• nome, morada, endereço de e-mail e número de telefone;</div>
      <div class="text">• dados de faturação e informações de entrega;</div>
      <div class="text">• IBAN, dados da conta bancária, PayPal, Revolut ou outras informações de pagamento;</div>
      <div class="text">• informações sobre o dispositivo, tais como marca, modelo, IMEI, número de série, estado do dispositivo e detalhes da avaliação;</div>
      <div class="text">• histórico de transações, pedidos de reembolso, pedidos de devolução do dispositivo e histórico de comunicações;</div>
      <div class="text">• comunicações com o serviço de apoio ao cliente;</div>
      <div class="text">• informações fornecidas em inquéritos, campanhas, promoções ou concursos;</div>
      <div class="text">• preferências de marketing e subscrições de newsletters.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">2. Dados pessoais recolhidos automaticamente</div>
    <div class="text-box">
      <div class="text">Para além dos dados pessoais fornecidos por si, podemos recolher automaticamente informações relacionadas com a utilização dos nossos Serviços, incluindo:</div>
      <div class="text">• endereço IP;</div>
      <div class="text">• tipo e versão do navegador;</div>
      <div class="text">• sistema operativo;</div>
      <div class="text">• identificadores de sessão;</div>
      <div class="text">• identificadores do dispositivo;</div>
      <div class="text">• informações de geolocalização;</div>
      <div class="text">• dados relativos à interação com o website;</div>
      <div class="text">• páginas visitadas e comportamento de navegação;</div>
      <div class="text">• informações de registo;</div>
      <div class="text">• cookies e informações de rastreamento relacionadas.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">3. Dados pessoais obtidos junto de terceiros</div>
    <div class="text-box">
      <div class="text">Podemos obter dados pessoais através de:</div>
      <div class="text">• Shopify;</div>
      <div class="text">• Amazon;</div>
      <div class="text">• TEMU;</div>
      <div class="text">• Back Market;</div>
      <div class="text">• prestadores de serviços de pagamento;</div>
      <div class="text">• prestadores de serviços logísticos;</div>
      <div class="text">• prestadores de serviços de prevenção de fraude;</div>
      <div class="text">• parceiros de marketing e análise;</div>
      <div class="text">• bases de dados públicas, quando permitido por lei.</div>
      <div class="text">Estas informações podem incluir dados relativos a encomendas, entregas, confirmação de transações e informações utilizadas para prevenir fraudes.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">4. Dados não pessoais</div>
    <div class="text-box">
      <div class="text">Podemos tratar informações agregadas ou anonimizadas que não permitam identificá-lo diretamente.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">III.  Como utilizamos os seus dados pessoais</div>
    <div class="text-box">
      <div class="text">Utilizamos os seus dados pessoais para as seguintes finalidades:</div>
      <div class="text">• prestar os nossos Serviços;</div>
      <div class="text">• processar transações de recompra, revenda, pagamentos, envios, devoluções e reembolsos;</div>
      <div class="text">• organizar serviços logísticos e de entrega;</div>
      <div class="text">• verificar informações sobre os dispositivos e respetiva propriedade;</div>
      <div class="text">• comunicar consigo relativamente às suas transações ou pedidos de apoio ao cliente;</div>
      <div class="text">• prestar apoio ao cliente;</div>
      <div class="text">• melhorar os nossos Serviços e a experiência do utilizador;</div>
      <div class="text">• prevenir fraudes e analisar riscos;</div>
      <div class="text">• realizar análises internas e atividades operacionais;</div>
      <div class="text">• enviar comunicações de marketing, quando permitido;</div>
      <div class="text">• gerir promoções, campanhas e concursos;</div>
      <div class="text">• cumprir obrigações legais;</div>
      <div class="text">• exercer ou defender direitos e reclamações legais.</div>
      <div class="text">Não tomamos decisões baseadas exclusivamente no tratamento automatizado que produzam efeitos jurídicos sobre si ou que o afetem de forma igualmente significativa.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">IV. Como utilizamos cookies e tecnologias semelhantes</div>
    <div class="text-box">
      <div class="text">Utilizamos cookies e tecnologias semelhantes nos nossos websites e Serviços.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">1. O que são cookies?</div>
    <div class="text-box">
      <div class="text">Os cookies são pequenos ficheiros de texto armazenados no seu dispositivo.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">2. Como utilizamos os cookies?</div>
    <div class="text-box">
      <div class="text">Utilizamos cookies para:</div>
      <div class="text">• assegurar o funcionamento dos nossos Serviços;</div>
      <div class="text">• memorizar as preferências dos utilizadores;</div>
      <div class="text">• analisar o tráfego do website;</div>
      <div class="text">• melhorar a funcionalidade do website;</div>
      <div class="text">• personalizar conteúdos e publicidade;</div>
      <div class="text">• medir a eficácia da publicidade.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">3. Tipos de dados recolhidos através de cookies</div>
    <div class="text-box">
      <div class="text">Estes podem incluir:</div>
      <div class="text">• endereços IP;</div>
      <div class="text">• tipo de navegador;</div>
      <div class="text">• sistema operativo;</div>
      <div class="text">• páginas visitadas;</div>
      <div class="text">• dados da sessão;</div>
      <div class="text">• informações sobre cliques;</div>
      <div class="text">• informações de localização.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">4. Rastreamento e publicidade de terceiros</div>
    <div class="text-box">
      <div class="text">Podemos trabalhar com parceiros externos, tais como Google, Meta, TikTok e outros prestadores de serviços de análise ou publicidade.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">5. Gestão de cookies</div>
    <div class="text-box">
      <div class="text">Pode gerir ou desativar os cookies através das definições do seu navegador ou das preferências disponibilizadas no banner de cookies.</div>
      <div class="text">Exemplos de cookies que podemos utilizar:</div>
      <div class="text">Categoria</div>
      <div class="text">Nome</div>
      <div class="text">Fornecedor</div>
      <div class="text">Finalidade</div>
      <div class="text">Duração</div>
      <div class="text">Tipoe</div>
      <div class="text">Estritamente necessários</div>
      <div class="text">session_id</div>
      <div class="text">danghuan.eu</div>
      <div class="text">Gestão da sessão do utilizador</div>
      <div class="text">Sessão</div>
      <div class="text">Próprio-party</div>
      <div class="text">Funcionais</div>
      <div class="text">language_pref</div>
      <div class="text">danghuan.eu</div>
      <div class="text">Memorizar preferências de idioma</div>
      <div class="text">1 ano</div>
      <div class="text">Próprio-party</div>
      <div class="text">Analíticos</div>
      <div class="text">_ga</div>
      <div class="text">Google Analytics</div>
      <div class="text">Análise do website</div>
      <div class="text">2 anos</div>
      <div class="text">Terceiros-party</div>
      <div class="text">Publicidade</div>
      <div class="text">_fbp</div>
      <div class="text">Meta</div>
      <div class="text">Medição da eficácia da publicidade</div>
      <div class="text">3 meses</div>
      <div class="text">Terceiros-party</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">V. Durante quanto tempo conservamos os seus dados pessoais</div>
    <div class="text-box">
      <div class="text">Conservamos os seus dados pessoais apenas durante o período necessário para cumprir as finalidades descritas nesta Política de Privacidade, salvo se a legislação aplicável exigir um período de conservação mais longo.</div>
      <div class="text">Após o termo do período de conservação aplicável, eliminaremos ou anonimizaremos os seus dados pessoais.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">VI. Como partilhamos os seus dados pessoais</div>
    <div class="text-box">
      <div class="text">Podemos partilhar os seus dados pessoais com:</div>
      <div class="text">• empresas afiliadas;</div>
      <div class="text">• prestadores de serviços de pagamento, tais como PayPal, Revolut, VISA, Mastercard e Stripe;</div>
      <div class="text">• prestadores de serviços logísticos, tais como UPS, Correos, DPD, Royal Mail, NACEX e FedEx;</div>
      <div class="text">• plataformas parceiras, tais como Shopify, Amazon, TEMU e Back Market;</div>
      <div class="text">• prestadores de serviços de marketing e análise;</div>
      <div class="text">• consultores profissionais e prestadores de serviços de TI;</div>
      <div class="text">• autoridades públicas e entidades reguladoras, quando exigido por lei.</div>
      <div class="text">Não vendemos os seus dados pessoais a terceiros.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">VII. Transferências internacionais de dados pessoais</div>
    <div class="text-box">
      <div class="text">Os seus dados pessoais podem ser transferidos e tratados em países fora da sua jurisdição.</div>
      <div class="text">Quando exigido pela legislação aplicável, utilizamos salvaguardas adequadas, incluindo:</div>
      <div class="text">• cláusulas contratuais-tipo;</div>
      <div class="text">• decisões de adequação;</div>
      <div class="text">• outros mecanismos de transferência legalmente reconhecidos.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">VIII. Como protegemos os seus dados pessoais</div>
    <div class="text-box">
      <div class="text">Aplicamos medidas técnicas e organizativas de segurança, incluindo:</div>
      <div class="text">• eencriptação;</div>
      <div class="text">• armazenamento seguro;</div>
      <div class="text">• controlos de acesso;</div>
      <div class="text">• procedimentos de autenticação;</div>
      <div class="text">• obrigações internas de confidencialidade;</div>
      <div class="text">• monitorização de fraude;</div>
      <div class="text">• métodos seguros de transmissão de dados.</div>
      <div class="text">No entanto, tenha em atenção que nenhum sistema de transmissão ou armazenamento de dados é totalmente seguro.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">IX. Os seus direitos relativos aos dados pessoais</div>
    <div class="text-box">
      <div class="text">Dependendo da legislação aplicável, poderá ter os seguintes direitos:</div>
      <div class="text">• tdireito de acesso aos seus dados pessoais;</div>
      <div class="text">• direito de retificação de dados inexatos;</div>
      <div class="text">• direito ao apagamento dos seus dados pessoais;</div>
      <div class="text">• direito à limitação do tratamento;</div>
      <div class="text">• direito de oposição ao tratamento;</div>
      <div class="text">• direito à portabilidade dos dados;</div>
      <div class="text">• direito de retirar o consentimento;</div>
      <div class="text">• direito de apresentar uma reclamação junto de uma autoridade de controlo.</div>
      <div class="text">Para exercer os seus direitos, pode contactar-nos através de: <span class="email">privacy@danghuan.eu</span></div>
      <div class="text">Poderemos solicitar a verificação da sua identidade antes de processarmos o seu pedido.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">X. Como tratamos os dados pessoais de crianças</div>
    <div class="text-box">
      <div class="text">Os nossos Serviços destinam-se a adultos com idade igual ou superior a 18 anos.</div>
      <div class="text">Se verificarmos que recolhemos dados pessoais de uma criança sem o consentimento adequado, eliminaremos esses dados logo que razoavelmente possível.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">XI. Websites de terceiros</div>
    <div class="text-box">
      <div class="text">Os nossos Serviços podem conter ligações para websites, plataformas ou serviços de terceiros.</div>
      <div class="text">Não somos responsáveis pelas práticas de privacidade desses terceiros.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">XII. Utilização de nomes e logótipos de marcas de terceiros</div>
    <div class="text-box">
      <div class="text">O nosso website pode apresentar nomes e logótipos de marcas como Apple, Samsung, OPPO, OnePlus, vivo, Xiaomi, Google e outras, exclusivamente para identificar dispositivos compatíveis com os nossos Serviços.</div>
      <div class="text">Todas as marcas comerciais pertencem aos respetivos proprietários.</div>
      <div class="text">A Danghuan é um prestador de serviços independente e não está afiliada a essas marcas nem é por elas recomendada, salvo indicação expressa em contrário.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">XIII. Atualizações desta Política de Privacidade</div>
    <div class="text-box">
      <div class="text">Reservamo-nos o direito de atualizar periodicamente esta Política de Privacidade.</div>
      <div class="text">A versão mais recente estará sempre disponível no nosso website.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">B. DISPOSIÇÕES RELATIVAS AO RGPD</div>
    <div class="text-box">
      <div class="text">As seguintes disposições aplicam-se exclusivamente às pessoas localizadas na Europa.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">I. Bases jurídicas para o tratamento</div>
    <div class="text-box">
      <div class="text">Tratamos os seus dados pessoais com base:</div>
      <div class="text">• no seu consentimento;</div>
      <div class="text">• na necessidade de execução de um contrato;</div>
      <div class="text">• na necessidade de cumprimento de obrigações legais;</div>
      <div class="text">• nos nossos interesses legítimos.</div>
      <div class="text">Os nossos interesses legítimos podem incluir:</div>
      <div class="text">• prevenção de fraude;</div>
      <div class="text">• melhoria dos Serviços;</div>
      <div class="text">• análise;</div>
      <div class="text">• apoio ao cliente;</div>
      <div class="text">• cibersegurança;</div>
      <div class="text">• gestão das atividades comerciais;</div>
      <div class="text">• exercício e defesa de direitos legais.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">II. Informações adicionais sobre transferências internacionais de dados</div>
    <div class="text-box">
      <div class="text">Quando os dados pessoais são transferidos para fora da Europa, asseguramos a aplicação de salvaguardas adequadas, incluindo:</div>
      <div class="text">• decisões de adequação;</div>
      <div class="text">• cláusulas contratuais-tipo;</div>
      <div class="text">• outros mecanismos de transferência legalmente reconhecidos.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">III. Informações adicionais sobre cookies</div>
    <div class="text-box">
      <div class="text">Poderão ser disponibilizadas informações adicionais sobre cookies na nossa Política de Cookies ou através do banner de cookies.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">IV. Informações adicionais sobre os seus direitos</div>
    <div class="text-box">
      <div class="text">Nos termos do RGPD, poderá ainda ter:</div>
      <div class="text">• direito de se opor ao tratamento baseado em interesses legítimos;</div>
      <div class="text">• direito de se opor ao marketing direto;</div>
      <div class="text">• direito à limitação do tratamento;</div>
      <div class="text">• direito de apresentar uma reclamação junto da autoridade de controlo competente.</div>
      <div class="text">• Em Portugal, a autoridade de controlo competente em matéria de proteção de dados é a Comissão Nacional de Proteção de Dados (CNPD).</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">V. Contact Details</div>
    <div class="text-box">

    </div>
  </div>
  <div class="paragraph">
    <div class="title">Para questões relacionadas com a proteção de dados pessoais, pode contactar-nos através de:</div>
    <div class="text-box">
      <div class="text">Danghuan Europe S.L.Email: <span class="email">privacy@danghuan.euWebsite</span>: <a href="https://<a href="https://www.danghuan.eu"" target="_blank">www.danghuan.eu"</a> target="_blank">https://<a href="https://www.danghuan.eu" target="_blank">www.danghuan.eu</a></a></div>
      <div class="text">Pode igualmente apresentar uma reclamação junto da autoridade de controlo competente em matéria de proteção de dados pessoais.</div>
    </div>
  </div>
`;
